import { render, staticRenderFns } from "./ApplicationReviewPanels.vue?vue&type=template&id=56030261&scoped=true&"
import script from "./ApplicationReviewPanels.vue?vue&type=script&lang=js&"
export * from "./ApplicationReviewPanels.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationReviewPanels.vue?vue&type=style&index=0&id=56030261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56030261",
  null
  
)

export default component.exports